<div style="color: black; position: relative; left: 900px; top: 50px;">
    <h1>Encomienda cargada</h1>
    <h3>Compuerta cerrada correctamente</h3>
</div>
<img src="./assets/img/encomiendaCargada2.PNG" style="width: 330px; position: relative; left: 1050px; top: 100px;">
<span>Espera unos segundos...</span>
<button (click)="continuar()" style="position: relative; left: 1100px; top: 300px;">Continuar</button>
